import React from "react";
import {
    withNamespaces,
} from "react-i18next";

import AudienceCapabilitiesCard from "./AudienceCapabilitiesCard";
import CapabilitiesVideo from "./CapabilitiesVideo";
import SecurityCapabilitiesCard from "./SecurityCapabilitiesCard";
import "./style.less";

export function PlatformCapabilitiesSection({
    t,
}) {
    return (
        <section
            className="platform-capabilities landing-section landing-section--first"
            id="solutions"
        >
            <div className="container public-site-shell">
                <div className="platform-capabilities__heading landing-section-heading">
                    <div>
                        <span className="platform-capabilities__eyebrow landing-section-heading__eyebrow">
                            {t(
                                "main.landing.capabilities.eyebrow"
                            )}
                        </span>

                        <h2 className="platform-capabilities__title landing-section-heading__title">
                            {t(
                                "main.landing.capabilities.title"
                            )}
                        </h2>
                    </div>

                    <p className="landing-section-heading__intro">
                        {t(
                            "main.landing.capabilities.intro"
                        )}
                    </p>
                </div>

                <div className="platform-capabilities__grid">
                    <AudienceCapabilitiesCard
                        t={t}
                    />

                    <SecurityCapabilitiesCard
                        t={t}
                    />
                </div>

                <CapabilitiesVideo
                    t={t}
                />
            </div>
        </section>
    );
}

export default withNamespaces(
    "translation"
)(PlatformCapabilitiesSection);
